'use client';

import { Button, ButtonProps } from '@jouzen/ecom-components/v3/Button';
import { cx } from 'class-variance-authority';
import { MouseEventHandler } from 'react';

export interface FormActionButtonProps extends ButtonProps {
  readonly full?: boolean;
}

export const FormActionButton = ({
  children,
  className,
  full,
  loading,
  onClick,
  ...props
}: FormActionButtonProps) => {
  const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    if (!loading && typeof onClick === 'function') {
      onClick(e);
    }
  };

  return (
    <Button
      data-testid="form-action-button"
      {...props}
      className={cx(
        {
          'self-center md:self-end': !full,
          'w-full': full,
        },
        className,
      )}
      loading={loading}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
};

export default FormActionButton;
